interface SectionHeaderProps {
  id?: string;
  label?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  className?: string;
}

export default function SectionHeader({
  id,
  label,
  title,
  description,
  align = 'left',
  className = '',
}: SectionHeaderProps) {
  const alignClass = align === 'center' ? 'text-center mx-auto' : '';

  return (
    <header className={`mb-10 md:mb-12 max-w-3xl ${alignClass} ${className}`}>
      {label && (
        <p className="section-label mb-3">{label}</p>
      )}
      <h2 id={id} className="section-title">
        {title}
      </h2>
      {description && (
        <p className={`section-description mt-3 ${align === 'center' ? 'mx-auto' : ''}`}>
          {description}
        </p>
      )}
    </header>
  );
}
